import { MANAGER_TYPES } from 'resources/user/user.constants';
import useGetCompanyUsers from './useGetCompanyUsers';


export default function useTeamMembers(companyId, queryOptions) {
  return useGetCompanyUsers(companyId, {
    ...queryOptions,
    select: (users) => users.filter((user) => Object.values(MANAGER_TYPES).includes(user.type)),
  });
}
